/*
 * This file is part of glowingblue/orell-facade.
 *
 * Copyright (c) 2023 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import { slug } from '../../common';
import app from 'flarum/forum/app';
import Page from 'flarum/common/components/Page';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import ComposeBannerHero from './ComposeBannerHero';
import BannerForm from './form/BannerForm';

const t = app.translator.trans.bind(app.translator);
const prfx = `${slug}.forum.compose`;

export default class ComposeBannerPage extends Page {
	oninit(vnode) {
		super.oninit(vnode);

		// Get the `edit` parameter from the URL
		const editId = m.route.param('edit');
		if (editId) {
			this.banner = app.store.getById('banners', editId);

			if (!this.banner) {
				this.loading = true;

				app.store.find('banners', editId).then((item) => {
					this.banner = item;
					this.loading = false;
					app.setTitle(t(`${prfx}.${!!this.banner?.id() ? 'edit' : 'add'}_title`));
					m.redraw();
				});
			}
		} else {
			this.banner = app.store.createRecord('banners');
		}

		app.history.push('compose-banner');
		this.bodyClass = 'App--compose-banner';
		app.setTitle(t(`${prfx}.${!!this.banner?.id() ? 'edit' : 'add'}_title`));
	}

	view() {
		if (this.loading) {
			return <LoadingIndicator />;
		}

		return (
			<div className="ComposeBannerPage">
				<ComposeBannerHero banner={this.banner} />
				<div className="container">
					<BannerForm banner={this.banner} />
				</div>
			</div>
		);
	}
}
